import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Boxes, Loader2, MailCheck, MailX } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Enlace inválido: falta el token de verificación.");
      return;
    }
    api.post("/auth/verify-email", { token })
      .then(({ data }) => { setStatus("ok"); setMessage(data.message); })
      .catch((err) => { setStatus("error"); setMessage(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo verificar el correo."); });
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0B] text-white p-6">
      <div data-testid="verify-email-card" className="relative w-full max-w-sm bg-[#121214]/90 border border-white/10 rounded-2xl p-8 shadow-[0_30px_80px_rgba(0,0,0,0.6)] animate-fade-up text-center">
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="h-9 w-9 rounded-lg bg-primary flex items-center justify-center">
            <Boxes className="h-5 w-5" />
          </div>
          <span className="font-display font-extrabold text-xl">Portal GA</span>
        </div>
        {status === "loading" && (
          <div className="py-6" data-testid="verify-loading">
            <Loader2 className="h-8 w-8 animate-spin mx-auto text-primary" />
            <p className="text-sm text-zinc-400 mt-4">Verificando tu correo...</p>
          </div>
        )}
        {status === "ok" && (
          <div data-testid="verify-success">
            <div className="h-14 w-14 rounded-full bg-[#00E676]/15 flex items-center justify-center mx-auto mb-4 animate-pop">
              <MailCheck className="h-7 w-7 text-[#00E676]" />
            </div>
            <h1 className="font-display text-2xl font-bold mb-2">¡Correo verificado!</h1>
            <p className="text-sm text-zinc-400 mb-6">{message}</p>
            <Link to="/login" data-testid="verify-goto-login" className="block w-full bg-primary hover:bg-[#FF5047] text-white font-semibold py-2.5 rounded-lg transition-colors">
              Iniciar sesión
            </Link>
          </div>
        )}
        {status === "error" && (
          <div data-testid="verify-error">
            <div className="h-14 w-14 rounded-full bg-red-500/15 flex items-center justify-center mx-auto mb-4 animate-pop">
              <MailX className="h-7 w-7 text-red-400" />
            </div>
            <h1 className="font-display text-2xl font-bold mb-2">No se pudo verificar</h1>
            <p className="text-sm text-zinc-400 mb-6">{message}</p>
            <Link to="/login" data-testid="verify-error-goto-login" className="block w-full bg-white/5 hover:bg-white/10 border border-white/10 text-white font-semibold py-2.5 rounded-lg transition-colors">
              Volver al inicio de sesión
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
